import { useEffect } from "react";
import { routes, useSimpleKitContext } from "./SimpleKitContext";
import { NetworkSymbols } from "based-auth/networks";
import { useAccount, useEthWallets, useSolanaWallet } from "@/react/hooks";
import {
  AllChains,
  chainSol,
  chainSolDevnet,
  isMainnet,
} from "based-auth/chains";
import { useQueryClient } from "@tanstack/react-query";
import { signOut } from "next-auth/react";

export function SimpleKit() {
  const { address: account, social, network } = useAccount();
  const { open, setOpen, setRouter, setPendingItem } = useSimpleKitContext();
  const { solWallets } = useSolanaWallet();
  const queryClient = useQueryClient();
  const { data: ethWallets } = useEthWallets();

  useEffect(() => {
    solWallets.forEach((connector) => {
      connector.on("connect", (publicKey: any) => {
        if (!account || social || network !== NetworkSymbols.sol) {
          return;
        }
        console.log({ account, social, network });
        setOpen(() => {
          setRouter(() => {
            setPendingItem({
              id: connector.name,
              name: connector.name,
              logo: connector.icon,
              network: NetworkSymbols.sol,
              chainId: isMainnet ? chainSol.id : chainSolDevnet.id,
              address: publicKey.toBase58(),
            });
            return routes.accountSigning;
          });
          return true;
        });
      });
      connector.on("error", (error: any) => {
        console.log("sol error", error, connector.name);
      });
      connector.on("disconnect", () => {
        signOut({
          redirect: false,
        });
      });
    });
    return () => {
      solWallets.forEach((connector) => {
        connector.off("connect");
        connector.off("error");
        connector.off("disconnect");
      });
    };
  }, [solWallets]);

  useEffect(() => {
    ethWallets.forEach((connector: any) => {
      connector.emitter.on("connect", ({ accounts, chainId }: any) => {
        const chain = AllChains.filter(
          (chain) => chain.network.symbol === NetworkSymbols.eth
        ).find((chain) => chain.id === chainId);
        if (!chain) {
          return;
        }
        setOpen(() => {
          setRouter(() => {
            setPendingItem({
              id: connector.id,
              name: connector.name,
              logo: connector.icon,
              network: NetworkSymbols.eth,
              chainId: chainId,
              address: accounts[0],
            });
            return routes.accountSigning;
          });
          return true;
        });
      });
      connector.emitter.on("change", ({ chainId }: any) => {
        setOpen(() => {
          setRouter(() => {
            setPendingItem({
              name: connector.name,
              logo: connector.icon,
              args: [chainId],
            });
            return routes.switchingChain;
          });
          return true;
        });
      });
      connector.emitter.on("display_uri", (uri: any) => {
        console.log("eth display_uri", uri);
      });
      connector.emitter.on("error", (error: any) => {
        console.log("eth error", error);
      });
      connector.emitter.on("disconnect", () => {
        signOut({
          redirect: false,
        });
      });
    });
    return () => {
      ethWallets.forEach((connector: any) => {
        connector.emitter.off("connect");
        connector.emitter.off("change");
        connector.emitter.off("display_uri");
        connector.emitter.off("error");
        connector.emitter.off("disconnect");
      });
    };
  }, [ethWallets]);

  useEffect(() => {
    if (!open) {
      localStorage.setItem("last-based-auth-wallet-connect", "");
    }
  }, [open]);

  useEffect(() => {
    queryClient.fetchQuery({
      queryKey: ["use-social-providers"],
    });
  }, []);

  return <></>;
}
